import { TabType } from "../app/components/MyAccountV2/MyAccountTabs/consts";

export const MY_ACCOUNT_TAB_QUERY = "tab";

/** Filtr powiązanej osoby w „Moje konto” (format wartości: `objectDb,objectId`). */
export const MY_ACCOUNT_ACCOUNT_IDS_QUERY = "accountIds";

export function parseAccountIdsFromSearch(search: string): string | undefined {
  const params = new URLSearchParams(search);
  const raw = params.get(MY_ACCOUNT_ACCOUNT_IDS_QUERY)?.trim();
  return raw || undefined;
}

/** Ustawia lub usuwa `accountIds` w query (pusta wartość = brak parametru). Zwraca sam query string. */
export function setAccountIdsInSearch(currentSearch: string, accountIds: string | undefined | null): string {
  const params = new URLSearchParams(currentSearch);
  if (accountIds == null || accountIds === "") {
    params.delete(MY_ACCOUNT_ACCOUNT_IDS_QUERY);
  } else {
    params.set(MY_ACCOUNT_ACCOUNT_IDS_QUERY, accountIds);
  }
  return params.toString();
}

const TAB_ALIASES: Record<string, TabType> = {
  reservation: "reservations",
  reservations: "reservations",
  rezerwacje: "reservations",
  tickets: "tickets",
  ticket: "tickets",
  ecard: "ecard",
  documents: "documents",
  document: "documents",
  people: "people",
  osoby: "people",
  settings: "settings",
  ustawienia: "settings",
};

const ALL_TAB_IDS: TabType[] = [
  "reservations",
  "tickets",
  "ecard",
  "documents",
  "people",
  "settings",
];

export function parseTabQuery(search: string): TabType | null {
  const params = new URLSearchParams(search);
  const raw = params.get(MY_ACCOUNT_TAB_QUERY)?.trim().toLowerCase();
  if (!raw) return null;

  if (ALL_TAB_IDS.includes(raw as TabType)) {
    return raw as TabType;
  }

  const mapped = TAB_ALIASES[raw];
  return mapped ?? null;
}

export interface TabVisibility {
  allowSubaccounts: boolean;
  ecardShowCode: boolean;
}

/** Zwraca tab z URL tylko jeśli jest dozwolony w konfiguracji. */
export function resolveTabFromQuery(search: string, visibility: TabVisibility): TabType | null {
  const tab = parseTabQuery(search);
  if (!tab) return null;
  if (tab === "people" && !visibility.allowSubaccounts) return null;
  if (tab === "ecard" && !visibility.ecardShowCode) return null;
  return tab;
}

/** Ustawia parametr `tab` zachowując pozostałe query (np. id placówki). Zwraca sam query string. */
export function mergeSearchWithTab(currentSearch: string, tab: TabType): string {
  const params = new URLSearchParams(currentSearch);
  params.set(MY_ACCOUNT_TAB_QUERY, tab);
  return params.toString();
}

/** Ustawia `tab` oraz opcjonalnie `accountIds` (pusta wartość = usuwa filtr konta). */
export function mergeSearchWithTabAndAccountIds(
  currentSearch: string,
  tab: TabType,
  accountIds: string | null | undefined
): string {
  const withTab = mergeSearchWithTab(currentSearch, tab);
  return setAccountIdsInSearch(withTab, accountIds ?? "");
}
